module.exports = __webpack_public_path__ + "static/media/EANPaylogoW.de502353.jpg";